import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";
import FieldView from "../../../../render/view";
import Moment from "moment";

export default function FieldDate_ManagementPreview(props: FieldManagementPreviewProps) {

    const model : any = {}
    model[props.field.fieldId] = Moment()

    return <FieldView field={props.field} model={model} />
}